import { onMounted, onBeforeUnmount } from "vue";

export function useElementObserver(selector: string, callback: (element: Element) => void): void {
  let observer: MutationObserver | null = null;

  onMounted(() => {
    observer = new MutationObserver((mutationsList: MutationRecord[]) => {
      for (const mutation of mutationsList) {
        if (mutation.type === "childList") {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              const el = node as Element;

              if (el.matches(selector)) {
                callback(el);
              }

              const found = el.querySelector(selector);
              if (found) {
                callback(found);
              }
            }
          });
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });

  onBeforeUnmount(() => {
    observer?.disconnect();
  });
}
